/**
 * Users
 */

// React
import React, {FunctionComponent, useEffect, useState, useContext} from 'react';

// Context
import AuthContext from '../../authContext';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {
  getCentersAction,
  updateCenterActions,
  createCentersActions,
  getAllCentersReportAction,
  getSupervisorsAction,
  updateCenterStatusActions,
  getCentersActiveCountActions,
  getCentersDeactiveCountActions,
} from './actions';
import {Store} from '../../redux/reducers';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectList,
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectCountActiveList,
  makeSelectCountDeactiveList,
  makeSelectAllList,
  makeSelectSupervisorsList,
} from './selectors';

// Components
import Pagination from '@material-ui/lab/Pagination';
import List from './components/list';
import Edit from './components/edit';
import Add from './components/add';
import Detail from './components/detail';
import Csv from './components/csv';
import RenderFilter from '../../utils/listDaynamicFilterHookForm';
import Can from '../../components/Can';

// UI
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {
  Typography,
  Paper,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  DialogTitle,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  InputBase,
  ClickAwayListener,
  Card,
  CardHeader,
  CardContent,
  LinearProgress,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiPlus,
  mdiArrowRight,
  mdiChevronDown,
  mdiMapMarkerRadiusOutline,
  mdiCheck,
  mdiClose,
  mdiMagnify,
  mdiMapMarkerPlusOutline,
} from '@mdi/js';

// Helper
import {removeEmptyValueObject} from '../../utils/helpers';
import useQuery from '../../utils/hook/useQuery';

// Type
import {
  Props,
  SelectorProps,
  PayloadUpdate,
  PayloadCreate,
  Center,
} from './interfaces';
import type {Filter} from '../../utils/listDaynamicFilter';
import clsx from 'clsx';
import {useForm} from 'react-hook-form';
import theme from '../../theme';
import {Active, Inactive} from './customIcon';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      padding: '10px 0',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    cards: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
    },
    boxshadow: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      transform: 'translateY(-3px)',
      boxShadow: '-4px 4px 12px 0px rgba(0,0,0,0.15) !important',
    },
    iconHeader: {
      position: 'absolute',
      top: '5px',
      right: '5px',
    },
    cardContent: {
      marginTop: '-20px',
      display: 'flex',
    },
    hover: {
      '&:hover': {
        curser: 'pointer',
      },
    },
    chart: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    progress: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      paddingTop: '8px',
      paddingRight: '24px',
      paddingBottom: '8px',
      paddingLeft: '50px',
      marginLeft: '-35px',
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    allCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#B297A7',
      },
    },
    activeCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#039590',
      },
    },
    diactiveCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#ddd',
      },
    },
    checkIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: '#039590',
      },
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      color: '#8A8A8A',
      fontSize: '16px',
      fontWeight: 500,
      marginRight: '8px',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '21px',
      fontWeight: 500,
    },
    showCount: {
      '& .MuiSelect-icon': {
        color: '#DFA01F',
      },
    },
  })
);

// Const
const translate = {
  edit: 'ویرایش',
  detail: 'جزیيات مرکز',
  assign: 'لیست مراکز',
} as any;

const Centers: FunctionComponent<Props> = (props: Props) => {
  const authContext = useContext(AuthContext);
  const [filters, setFilters] = useState([] as Filter[]);
  const [openSize, setOpenSize] = React.useState(false as boolean);

  const {filtersValues, setFiltersValues} = useQuery({
    page: 0,

    size: 10,
  });
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [openConfirmActive, setOpenConfirmActive] = useState(false as boolean);
  const [openDialog, setOpenDialog] = useState(false as boolean);
  const [type, setType] = useState('edit' as string);

  const [openAdd, setopenAdd] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const {register, handleSubmit, reset} = useForm<Inputs>();

  const [openFilterBox, setOpenFilterBox] = React.useState(false);

  const handleClick = () => {
    setOpenFilterBox(prev => !prev);
  };

  const onSubmit = (filtervalues: any) => {
    setFiltersValues({
      ...removeEmptyValueObject(filtervalues),
      page: 0,
      size: 10,
    });
    reset({});
    setOpenFilterBox(false);
  };

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
        'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false);
  };

  useEffect(() => {
    getCenters();
    setupFilters();
    getSupervisors();
    getCentersCount();
    getCentersDeactiveCount();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const classes = useStyles();

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({...filtersValues, page: page - 1});
  };

  const getCenters = () => {
    const {page, size} = filtersValues;
    const {partnerId, warehousesId} = props.match.params;
    props.centersDispatch({
      ...removeEmptyValueObject(filtersValues),
      warehousesId: {equals: warehousesId},
      partnerId: {equals: partnerId},
      page,
      size,
    });
  };

  const getCentersCount = () => {
    const {partnerId, warehousesId} = props.match.params;
    props.getCentersActiveCountDispatch({
      filters: {
        ...removeEmptyValueObject(filtersValues),
        partnerId: {equals: partnerId},
        warehousesId: {equals: warehousesId},
        status: {equals: 'ACTIVE'},
      },
    });
  };

  const getCentersDeactiveCount = () => {
    const {partnerId, warehousesId} = props.match.params;

    props.getCentersDeactiveCountDispatch({
      filters: {
        ...removeEmptyValueObject(filtersValues),

        warehousesId: {equals: warehousesId},
        partnerId: {equals: partnerId},
        status: {equals: 'SUSPENDED'},
      },
    });
  };

  const getSupervisors = () => {
    props.supervisorsDispatch({});
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'name.contains',
        label: 'نام مرکز',
      },
      {
        type: 'input',
        id: 'province.contains',
        label: 'استان',
      },
      {
        type: 'input',
        id: 'city.contains',
        label: 'شهر',
      },
      {
        type: 'input',
        id: 'phoneNumber.contains',
        label: 'تلفن مرکز',
      },
      {
        type: 'checkbox',
        id: 'status.in',
        label: 'وضعیت ',
        data: ['ACTIVE', 'SUSPENDED'],
        translateType: 'center',
      },
    ]);
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{value: unknown}>) => {
    setFiltersValues({...filtersValues, page: 0, size: event.target.value});
  };

  const handleDisableCenter = async () => {
    const {partnerId} = props.match.params;
    await props.updateCenterStatusDispatch({
      body: 'SUSPENDED',
      pagination: {...filtersValues, partnerId: {equals: partnerId}},
      id,
    });
    setOpenConfirmDisable(false);
    getCentersCount();
    getCentersDeactiveCount();
  };

  const handleActiveCenter = async () => {
    const {partnerId} = props.match.params;
    await props.updateCenterStatusDispatch({
      body: 'ACTIVE',
      pagination: {...filtersValues, partnerId: {equals: partnerId}},
      id,
    });
    setOpenConfirmActive(false);
    getCentersCount();
    getCentersDeactiveCount();
  };

  const handleOpenConfirmDisable = (centerId: number) => {
    setOpenConfirmDisable(true);
    setId(centerId);
  };

  const handleOpenConfirmActive = (centerId: number) => {
    setOpenConfirmActive(true);
    setId(centerId);
  };
  const handleOpen = (id: number, type: string) => {
    setType(type);
    setOpenDialog(true);
    setId(id);
  };

  const handleClose = () => {
    setOpenConfirmDisable(false);
    setOpenConfirmActive(false);
    setOpenDialog(false);
    setopenAdd(false);
  };

  const handleOpenConfirmUpdateState = (data: {id: number; body: any}) => {
    setId(data.id);
  };

  const handleCardClose = (id: any) => {
    const {page, size} = filtersValues;
    delete filtersValues['status.in'];
    setFiltersValues({
      ...removeEmptyValueObject(filtersValues),

      page: 0,
      size: 10,
    });
  };

  const handleCardClick = (name: string) => {
    const {page, size} = filtersValues;

    switch (name) {
      case 'active':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['ACTIVE'],
          page: 0,
          size: 10,
        });
        break;
      case 'inactive':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['SUSPENDED'],
          page: 0,
          size: 10,
        });
        break;
    }
  };

  const checkActiveCard = (name: string) => {
    const status = filtersValues['status.in']?.split(',') || [];
    switch (name) {
      case 'active':
        return status.includes('ACTIVE');
      case 'inactive':
        return status.includes('SUSPENDED');
    }
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={5}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h4" component="h2">
            {`مدیریت مراکز
           
            `}
          </Typography>

          {props.match.path !== '/your-centers' && (
            <Button
              aria-label="details"
              size="medium"
              onClick={() => window.history.back()}
            >
              <Icon path={mdiArrowRight} size={1} />
              {`بازگشت`}
            </Button>
          )}
        </Grid>
        <Grid
          container
          item
          xs={12}
          sm={6}
          alignItems="center"
          direction="row-reverse"
        >
          <Can
            role={authContext.user.role}
            perform="centers:createNewCenter"
            yes={() => (
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiPlus} size={1} />}
                onClick={() => setopenAdd(true)}
              >{`ایجاد مرکز جدید`}</Button>
            )}
          />{' '}
          <Can
            role={authContext.user.role}
            perform="centers:downloadReportCSV"
            yes={() => (
              <Csv
                getData={props.allCentersDispatch}
                data={props.allCentersList}
                id={props.match.params.partnerId}
                filtersValues={filtersValues}
                loading={props.loading}
              />
            )}
          />
        </Grid>
        <Grid container spacing={5} style={{margin: 0}}>
          <Grid container item xs={12} sm={6} alignItems="center" />
          <Grid item xs={12} sm={6}>
            <RenderFilter
              filters={filters}
              onFilter={(filtervalues: any) => {
                setFiltersValues({
                  ...removeEmptyValueObject(filtervalues),
                  page: 0,
                  size: 10,
                });
              }}
              mainFiltersCount={0}
              baseFilter={{
                type: 'input',
                id: 'centerName.equals',
                placeholder: 'نام مرکز',
              }}
              filterValues={filtersValues}
            />
          </Grid>
        </Grid>

        <Grid
          container
          spacing={2}
          md={12}
          style={{
            maxWidth: '120%',
            margin: '32px 1px',
          }}
        >
          <Grid container item lg={12} spacing={2} xs={12}>
            <Grid item md={6} lg={6} xs={12}>
              <Card
                className={
                  checkActiveCard('active') ? classes.boxshadow : classes.cards
                }
              >
                <CardHeader
                  action={
                    checkActiveCard('active') && (
                      <IconButton
                        aria-label="close"
                        onClick={handleCardClose}
                        className={classes.iconHeader}
                      >
                        <Icon
                          path={mdiClose}
                          size={1}
                          style={{
                            color: '#Ffffff',
                            backgroundColor: '#FFA65A',
                            borderRadius: '3px',
                          }}
                        />
                      </IconButton>
                    )
                  }
                />
                <CardContent className={classes.cardContent}>
                  <IconButton
                    type="submit"
                    onClick={name => handleCardClick('active')}
                    aria-label="search"
                    style={{
                      backgroundColor: '#D6EBD3',
                      // height: '30%',
                      // width: '28%',
                      borderRadius: '4px',
                      margin: '-20px 0',
                    }}
                  >
                    <Active />
                  </IconButton>
                  <Grid
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      marginRight: '10px',
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h6"
                      style={{fontWeight: 600, marginTop: '-20px'}}
                    >
                      {props.countActive}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '16px',
                        marginBottom: '-20px',
                        fontWeight: 550,
                        color: '#666666',
                      }}
                    >
                      مرکز فعال
                    </Typography>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={6} lg={6} xs={12}>
              <Card
                className={
                  checkActiveCard('inactive')
                    ? classes.boxshadow
                    : classes.cards
                }
              >
                <CardHeader
                  action={
                    checkActiveCard('inactive') && (
                      <IconButton
                        aria-label="close"
                        onClick={handleCardClose}
                        className={classes.iconHeader}
                      >
                        <Icon
                          path={mdiClose}
                          size={1}
                          style={{
                            color: '#Ffffff',
                            backgroundColor: '#FFA65A',
                            borderRadius: '3px',
                          }}
                        />
                      </IconButton>
                    )
                  }
                />
                <CardContent className={classes.cardContent}>
                  <IconButton
                    type="submit"
                    aria-label="search"
                    onClick={name => handleCardClick('inactive')}
                    style={{
                      backgroundColor: '#FCD4DA',
                      // height: '60%',
                      // width: '30%',
                      borderRadius: '4px',
                      margin: '-20px 0',
                    }}
                  >
                    <Inactive />
                  </IconButton>
                  <Grid
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      marginRight: '10px',
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h6"
                      style={{fontWeight: 600, marginTop: '-20px'}}
                    >
                      {props.countDeactive}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '16px',
                        marginBottom: '-20px',
                        fontWeight: 550,
                        color: '#666666',
                      }}
                    >
                      مرکز غیرفعال
                    </Typography>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          {/* <Grid item lg={4} xs={6}>
          <Card className={classes.chart}>
            <Grid
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Typography className={classes.typographyCards}>
                فعالترین فروشندگان
              </Typography>
              <Select value={'هفته گذشته'}>
                <MenuItem value={'هفته گذشته'}>هفته گذشته</MenuItem>
              </Select>
            </Grid>
            <div style={{marginTop: '10px'}}>
              <LinearProgress variant="determinate" value={50} />
            </div>
          </Card>
        </Grid> */}
          {/* <Grid item lg={3} xs={6}>
          <Card className={classes.progress}>
            <Typography
              className={classes.typographyCards}
              style={{
                width: '60%',
                textAlign: 'end',
              }}
            >
              محموله هر انبار
            </Typography>
            <div style={{textAlign: 'center', margin: '30px auto'}}>
              <CircularProgress
                size={140}
                style={{
                  position: 'relative',
                  color: '#6276F7',
                  // bottom: '-20%',
                  // right: '30%',
                }}
                variant="determinate"
                value={60}
                thickness={6}
              />
              <Typography
                style={{
                  position: 'relative',
                  bottom: '85px',
                  fontWeight: 900,
                }}
                variant="caption"
                component="div"
                color="textSecondary"
              >
                {'754 سفارش'}
              </Typography>
            </div>
          </Card>
        </Grid> */}
        </Grid>

        <Grid container item spacing={6}>
          <Grid item xs={12}>
            {props.loading ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              <List
                data={props.centersList}
                handleOpenConfirmDisable={handleOpenConfirmDisable}
                handleOpenConfirmActive={handleOpenConfirmActive}
                handleOpen={handleOpen}
                changeStatus={handleOpenConfirmUpdateState}
              />
            )}
          </Grid>
          <Grid id="showFilter" item xs={12} sm={6}>
            {props.centersList && (
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSize}
                  onClose={handleCloseSelect}
                  className={classes.showCount}
                  onOpen={() => setOpenSize(true)}
                  value={filtersValues.size}
                  onChange={handleChangeSizePage}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            )}
          </Grid>
          <Grid xs={12} sm={6} container item direction="row-reverse">
            {props.centersList && (
              <Pagination
                className={classes.pagination}
                count={Math.ceil(props.count / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        fullWidth
        open={openConfirmDisable || openConfirmActive}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          {` آیا از
           ${openConfirmDisable ? 'غیر' : ''}
           
           
           فعال کردن شرکت با نام
          "${props.centersList.find(center => center.id === id)?.name}"
          اطمینان دارید؟`}
        </DialogTitle>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleClose}
            variant="contained"
            color="primary"
          >
            {`خیر`}
          </Button>
          {openConfirmDisable ? (
            <Button
              onClick={handleDisableCenter}
              variant="outlined"
              color="primary"
            >
              {`بله`}
            </Button>
          ) : (
            <Button
              onClick={handleActiveCenter}
              variant="outlined"
              color="primary"
            >
              {`بله`}
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <Dialog
        maxWidth="md"
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          {type === 'edit' && (
            <>
              <div
                style={{
                  position: 'absolute',
                  left: '17px',
                  zIndex: 10,
                }}
              >
                <IconButton aria-label="close" onClick={handleClose}>
                  <Icon path={mdiClose} size={1} />
                </IconButton>
              </div>
              <div className={classes.checkIcon}>
                <Icon
                  path={mdiMapMarkerRadiusOutline}
                  size={4}
                  color={theme.palette.green.main}
                />
              </div>
              <Edit
                data={props.centersList.find(center => center.id === id)}
                partnerId={props.match.params.partnerId}
                supervisorsList={props.supervisorsList}
                close={handleClose}
                update={body => {
                  props.updateCenterDispatch({
                    body,
                    pagination: filtersValues,
                    id: props.match.params.partnerId,
                  });
                  handleClose();
                }}
              />
            </>
          )}

          {type === 'detail' && (
            <Detail data={props.centersList.find(center => center.id === id)} />
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        maxWidth={'md'}
        open={openAdd}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton aria-label="close" onClick={handleClose}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.checkIcon}>
            <Icon
              path={mdiMapMarkerPlusOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
          <Add
            partnerId={props.match.params.partnerId}
            supervisorsList={props.supervisorsList}
            close={handleClose}
            create={async (body: Center, callback: () => void) => {
              await props.createCenterDispatch({
                body,
                pagination: filtersValues,
                id: props.match.params.partnerId,
                callback,
              });
              // handleClose();
            }}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  centersList: makeSelectList(),
  supervisorsList: makeSelectSupervisorsList(),
  allCentersList: makeSelectAllList(),
  count: makeSelectCountList(),
  countActive: makeSelectCountActiveList(),
  countDeactive: makeSelectCountDeactiveList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    centersDispatch: (payload: Object) => dispatch(getCentersAction(payload)),
    supervisorsDispatch: (payload: Object) =>
      dispatch(getSupervisorsAction(payload)),
    allCentersDispatch: (payload: Object) =>
      dispatch(getAllCentersReportAction(payload)),
    updateCenterDispatch: (payload: PayloadUpdate) =>
      dispatch(updateCenterActions(payload)),
    createCenterDispatch: (payload: PayloadCreate) =>
      dispatch(createCentersActions(payload)),
    updateCenterStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(updateCenterStatusActions(payload)),
    getCentersActiveCountDispatch: (payload: {filters: any}) =>
      dispatch(getCentersActiveCountActions(payload)),
    getCentersDeactiveCountDispatch: (payload: {filters: any}) =>
      dispatch(getCentersDeactiveCountActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Centers);
